import * as React from 'react';
import { Fragment, useCallback, useEffect, useState } from 'react';
import {
  Count,
  Datagrid,
  DatagridConfigurable,
  ExportButton,
  Button,
  List,
  NumberField,
  Resource,
  SearchInput,
  SelectColumnsButton,
  SimpleShowLayout,
  TextField,
  TopToolbar,
  useDataProvider,
  useGetList,
  useListContext,
  useRecordContext,
  FunctionField,
} from 'react-admin';
import { useMediaQuery, Divider, Tabs, Tab, Theme, Box, Typography, Drawer } from '@mui/material';
import { useNavigate } from 'react-router';
import { redirect } from 'react-router-dom';
import { Claims } from './claims';
import SearchFilters from '../filters/filters';

const ListActions = () => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    // Close the drawer on page refresh
    setOpen(false);
  }, []);

  const toggleDrawer = () => {
    setOpen(!open);
  };
  return (
    <TopToolbar sx={{ position: 'relative', right: 10, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <SearchFilters toggleDrawer={toggleDrawer} />
      <ExportButton />
    </TopToolbar>
  );
};

const Report = () => (
  <List
    filterDefaultValues={{ status: 'claims' }}
    perPage={10}
    filters={claimsFilters}
    actions={<ListActions />}
    sx={{ textTransform: 'capitalize', fontWeight: 'x-small' }}
  >
    <TabbedDatagrid />
  </List>
);

const ClaimsShow = ({ ...props }) => {
  const record = useRecordContext();
  const clientnumber = record?.clientnumber;
  return <Claims options={{ clientId: clientnumber }} />;
};
const claimsFilters = [<SearchInput source="q" />];

const tabs = [{ id: 'claims', name: 'Clients' }];
const TotalField = ({ currency, record, source }) => {
  let value1 = isNaN(record[source[0]])
    ? 0
    : isNaN(parseFloat(record[source[0]]))
    ? 0
    : parseFloat(parseFloat(record[source[0]]).toFixed(2));
  let value2 = isNaN(record[source[1]])
    ? 0
    : isNaN(parseFloat(record[source[1]]))
    ? 0
    : parseFloat(parseFloat(record[source[1]]).toFixed(2));

  const value = value1 + value2;

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  let formattedvalue = parseFloat(value.toFixed(2));
  let color = formattedvalue > 0 ? 'green' : formattedvalue <= 0 ? 'red' : 'black';
  return currency ? (
    <span style={{ color: color, textAlign: 'right' }}>{formatter.format(formattedvalue)}</span>
  ) : (
    <span style={{ color: color, textAlign: 'right' }}>{formattedvalue}</span>
  );
};
const TabbedDatagrid = () => {
  const listContext = useListContext();
  const navigate = useNavigate();
  const { total } = useListContext();
  const { filterValues, setFilters, displayedFilters } = listContext;
  const isXSmall = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'));
  const [tabValue, setTabValue] = useState(0);

  return (
    <Fragment>
      <Tabs value={tabValue} onChange={(e, newVal) => setTabValue(newVal)} variant="fullWidth" indicatorColor="primary">
        <Tab
          sx={{ justifyContent: 'left', textTransform: 'capitalize' }}
          label={
            <span>
              Clients{' '}
              <Typography
                component="span"
                variant="body2"
                sx={{
                  borderRadius: '16px',
                  padding: '2px 8px',
                  lineHeight: 'inherit',
                  backgroundColor: 'rgba(210, 100, 80, 1)',
                  color: 'white',
                }}
              >
                {' '}
                {total}{' '}
              </Typography>
            </span>
          }
        />
      </Tabs>
      <Divider />
      {
        //isXSmall ? (
        //  <MobileGrid />
        // ) : (
        <>
          <Datagrid
            optimized
            expand={<ClaimsShow />}
            expandSingle
            isRowSelectable={false}
            rowClick={() => {}}
            sx={{ textTransform: 'capitalize', fontSize: 'x-small' }}
            bulkActionButtons={false}
          >
            <TextField
              sx={{ width: '10px !important', wordWrap: 'inherit' }}
              source="clientnumber"
              label="Client Number"
            />
            <TextField sx={{ width: '10px !important', wordWrap: 'inherit' }} source="clientname" label="Client Name" />

            {/*   <NumberField label="Paid Claims"
                                        source="totalpaidclaims"
                                    /> */}

            <FunctionField
              label="Claims"
              render={(record) => (
                <TotalField currency={false} record={record} source={['totalpaidclaims', 'totalreversalclaims']} />
              )}
            />

            <NumberField sx={{ textAlign: 'left' }} label="Reversals" source="totalreversalclaims" />

            <NumberField
              label="Paid"
              source="totalpaidclaimcost"
              options={{
                style: 'currency',
                currency: 'USD',
              }}
            />
            {/*    <NumberField label="Reversal Cost"
                                                 source="totalreversalclaimcost"
                                                 options={{
                                                     style: 'currency',
                                                     currency: 'USD',
                                                 }}
                                    /> */}

            <FunctionField
              sx={{ textAlign: 'right', alignment: 'right' }}
              label="Total Cost"
              render={(record) => (
                <TotalField currency={true} record={record} source={['totalpaidclaimcost', 'totalreversalclaimcost']} />
              )}
            />
            <FunctionField
              label="Copay"
              render={(record) => (
                <TotalField
                  currency={true}
                  record={record}
                  source={['totalpatientpaidliability', 'totalpatientreversalliability']}
                />
              )}
            />

            {/*  <NumberField label="Plan Paid"
                                                 source="totalplanpaidcost"
                                                 options={{
                                                     style: 'currency',
                                                     currency: 'USD',
                                                 }}
                                    />
                                    <NumberField label="Plan Reversal"
                                                 source="totalplanreversalcost"
                                                 options={{
                                                     style: 'currency',
                                                     currency: 'USD',
                                                 }}
                                    /> */}

            <FunctionField
              label="Plan Paid"
              render={(record) => (
                <TotalField currency={true} record={record} source={['totalplanpaidcost', 'totalplanreversalcost']} />
              )}
            />
            {/*  <NumberField label="Patient Paid Liability"
                                                 source="totalpatientpaidliability"
                                                 options={{
                                                     style: 'currency',
                                                     currency: 'USD',
                                                 }}
                                    />
                                    <NumberField label="Patient Reversal Liability"
                                                 source="totalpatientreversalliability"
                                                 options={{
                                                     style: 'currency',
                                                     currency: 'USD',
                                                 }}
                                    />
  
                                    <NumberField label="Patient Paid"
                                                 source="totalpatientpaidcost"
                                                 options={{
                                                     style: 'currency',
                                                     currency: 'USD',
                                                 }}
                                    />
                                    <NumberField label="Patient Reversal"
                                                 source="totalpatientreversalcost"
                                                 options={{
                                                     style: 'currency',
                                                     currency: 'USD',
                                                 }}
                                    />

                                    <FunctionField sx={{textAlign:'right'}}
                                        label="Plan Paid"
                                        render={record => <TotalField currency={true} record={record} source={['totalpatientpaidcost', 'totalpatientreversalcost']} />}
                                    />
 */}
          </Datagrid>
        </>
        //)
      }
    </Fragment>
  );
};

export default Report;
